<div class="toast-container">
  <div *ngFor="let message of toastyService.messages$ | async">
    <pulse-message
      *ngIf="message.dismissed === false"
      [message]="message"
    ></pulse-message>
  </div>
</div>
